export function OutlineLockOpenIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.01145 21H13.0178C14.1207 21 15.0146 20.106 15.0146 19.0032L15.0146 12.9984C15.0146 11.8956 14.1207 11.0016 13.0178 11.0016L5.01145 11.0016C3.90865 11.0016 3.01465 11.8956 3.01465 12.9984L3.01465 19.0032C3.01465 20.106 3.90865 21 5.01145 21Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0147 8.0016C21.0147 5.2416 18.7779 3 16.0131 3C13.2483 3 11.0115 5.2368 11.0115 8.0016V11.0016H14.0115V8.0016C14.0115 6.8976 14.9091 6 16.0131 6C17.1171 6 18.0147 6.8976 18.0147 8.0016H21.0147Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.01465 15V16.9968"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
